import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
  Card,
  Form
} from "react-bootstrap";
import { appConfig } from "../../config";

import ReactPaginate from "react-paginate";
import Switch from "react-switch";
var dateFormat = require("dateformat");

class ViewNormalOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // itemviewpage: 0,
      // itemsperviewPage: 5
    };
  }
  // itemsViewPageClick = ev => {
  //   const selecteditemPage = ev.selected;
  //   this.props.itemViewpageSelected({
  //     item: this.props.NormalViewordersToShow,
  //     page: selecteditemPage + 1
  //   });
  //   this.setState({ itemviewpage: selecteditemPage });
  // };

  // resetitemPage = () => {

  //   this.setState({
  //     ...this.state,
  //     itemviewpage: 0
  //   });
  // };

  render() {
    const data =
      this.props.NormalViewordersToShow &&
      this.props.NormalViewordersToShow.item
        ? this.props.NormalViewordersToShow &&
          this.props.NormalViewordersToShow.item
        : null;

    const items = this.props.normalOrderDtls
      ? this.props.normalOrderDtls
      : null;
    // const count =
    //   this.props.normalOrderDtlsCount && this.props.normalOrderDtlsCount;

    const {
      avlble,
      shwNormalrejectModal,
      shwNormalconfirmModal
      // itemviewpage,
      // itemsperviewPage
    } = this.state;

    const { itemsViewPageClick } = this;

    const viewcount =
      this.props.normalOrderDtlsCount && this.props.normalOrderDtlsCount;
    // let p1 = itemviewpage + 1;
    // let itemViewPageCount = Math.ceil(viewcount / itemsperviewPage);

    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.show}
            onHide={this.props.close}
            animation={false}
            size="lg"
            backdrop="static"
            className="Modalmodelboxdesigns"
            // style={{ backgroundColor: "rgba(0, 0, 0, 0.54)" }}
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white"
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Normal Order Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Row>
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div className="chemistdetails">
                    <p className="chemistdetailspera">
                      {data !== null && data.orderFrom
                        ? data.orderFrom.name + " " + data.orderFrom.lName
                        : null}
                    </p>
                    <p className="chemistdetailspera">
                      {" "}
                      {data !== null &&
                      data.orderFrom !== null &&
                      data.orderFrom
                        ? data.orderFrom.mobileNo
                        : null}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null &&
                      data.orderFrom !== null &&
                      data.orderFrom
                        ? data.orderFrom.email
                        : null}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null && data.addr},{" "}
                      {data !== null && data.pincode}
                    </p>
                  </div>
                </Col>

                <Col xs={12} sm={12} md={4} lg={4}></Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div>
                    <p className="chemistdetailspera">
                      {" "}
                      {data !== null && data.orderNo}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null && data.orderFromName}
                    </p>

                    <p className="chemistdetailspera">
                      {data !== null && data.city}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null && data.createdAt
                        ? dateFormat(data.createdAt, "dd-mmm-yyyy")
                        : null}
                    </p>
                  </div>
                </Col>
              </Row>
              <div className="coomonlinebody">
                <hr />
              </div>

              <Row>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <h3 className="itemdetailshd">Item Details</h3>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3}></Col>

                <Col xs={12} sm={12} md={3} lg={3}></Col>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <div>
                    <i className="cui-note icons cmnRecordIcon"></i>
                    <span className="cmnPageCount">
                      {" "}
                      {viewcount !== undefined ? viewcount : 0}
                    </span>
                    <span className="cmnResutText">Items</span>
                  </div>
                </Col>
              </Row>
              <Card.Body>
                <div className="viewnormaltablecommon">
                  <Table className="dashTable">
                    <thead className="tablecommonclr">
                      <tr>
                        <th>#</th>
                        <th>Item Code</th>
                        <th>Item Name</th>
                        <th style={{ width: "20%" }}>Quantity</th>
                        <th>Availability</th>
                      </tr>
                    </thead>
                    <tbody className="tablecommonclrtbody">
                      {this.props.normalOrderDtls &&
                        this.props.normalOrderDtls.map((item, i) => (
                          <tr key={i}>
                            <th scope="row">{i + 1}</th>
                            <td className="cmn_Cap">
                              {item !== null &&
                                item.itemCode !== null &&
                                item.itemCode !== undefined &&
                                item.itemCode.drugCode}
                            </td>
                            <td className="cmn_Cap">
                              {item !== null && item.itemName}
                            </td>
                            <td className="cmn_Cap">
                              {item !== null && item.qntty}
                            </td>
                            <td className="cmn_Cap">
                              {item !== null && item.avlble == true
                                ? "Available"
                                : "Not Available"}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                  {/* {itemViewPageCount > 1 ? (
                    <div className="paginationDiv">
                      <ReactPaginate
                        forcePage={itemviewpage}
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={itemViewPageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={itemsViewPageClick}
                        containerClassName={"pagination flex-wrap"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                      />
                    </div>
                  ) : null} */}
                  {(this.props.normalOrderDtls === undefined ||
                    (this.props.normalOrderDtls &&
                      this.props.normalOrderDtls.length === 0)) && (
                    <div>
                      <div className="noDataImgDiv">
                        <Image
                          className="noDataImg"
                          src={require("../../assets/img/nodata4.png")}
                        />
                      </div>
                      <div className="noDataTextDiv">No Items Found</div>
                    </div>
                  )}
                </div>
              </Card.Body>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#1768B7" }}>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ViewNormalOrders;
